module.exports = __webpack_public_path__ + "img/Icon_nav_back.b0caf880.svg";